import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NavController } from '@ionic/angular';
import { Category, CategoryService, Feature, FeatureService } from 'octali-lib-shop';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-category-filter-panel',
  templateUrl: './category-filter-panel.component.html',
  styleUrls: ['./category-filter-panel.component.scss'],
})
export class CategoryFilterPanelComponent implements OnInit {

  @Output() filter = new EventEmitter<Map<any,any>>();

  public category:Category;
  public categoriesId: Map<string,Category>;
  public features: Array<Feature>= [];
  public featuresId: Map<string, Feature>;
  public featuresValues : Map<any,any> =  new Map<any,any>();

  constructor(
    private categoryService: CategoryService,
    private featureService: FeatureService,
    private navCtrl: NavController
  ) { 
    combineLatest([
      this.featureService.getFeaturesIdObs(),
      this.categoryService.getCategoriesIdObs()
    ])
    .subscribe( ([featuresId, categoriesId]) => {
      if( categoriesId && featuresId )
        this.categoriesId = categoriesId;
        this.featuresId= featuresId;
    })
  }

  ngOnInit(): void {
  }

  setCategory(category:Category) {
    if(category != null && this.featuresId){
      this.category = category;
      this.features = [];
      this.category.features.forEach(featureId => {
        let  feat = this.featuresId.get(featureId);
        if(feat.filter.display)
          if( !this.features.includes( feat ))
            this.features.push(feat);
      })
    }
  }

  getFeaturesValues(feature:Feature) : any{
    if(this.featuresValues.has(feature.id)){
      return this.featuresValues.get(feature.id);
    }else{
        return [];
    }
  }

  selectFeatureValue(values){
    if(values.values.length == 0){
      if(this.featuresValues.has(values.feature.id) && this.featuresValues.get(values.feature.id)?.length>0){
        this.featuresValues.delete(values.feature.id);
        this.filter.emit(this.featuresValues);
      }
    }else{
      this.featuresValues.set(values.feature.id,values.values);
      this.filter.emit(this.featuresValues);
    }
      
  
    
  }

  trackFeatures(index:number,feature:Feature){
    return feature.id;
  }

  seeSubCategory( category ){
    let name = category.name.replace(/\/|\s/g, "-").toLowerCase();
    this.navCtrl.navigateRoot("categories/"+encodeURI(name.toLowerCase())+"/"+category.id);
    //this.router.navigate(["/product/category",category.id]);
  }
  applyFilters(){
    //console.log("appliquer les filtres");
    this.filter.emit(this.featuresValues);
  }

}
